import { BoxRadius, ColorTypes } from '@genial/design-tokens';
import { Box, IBoxProps } from 'native-base';
import React from 'react';

interface LateralBarProps extends IBoxProps {
  barColor: ColorTypes.Option | string;
}

export const LateralBar: React.FC<LateralBarProps> = ({ barColor, ...props }) => {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      bottom={0}
      w="4px"
      backgroundColor={barColor}
      borderTopLeftRadius={BoxRadius.sm}
      borderBottomLeftRadius={BoxRadius.sm}
      {...props}
    />
  );
};
